import { NativeMockBackground } from '../../widgets/NativeMockBackground';
import { InstallCard } from './components/InstallCard';

export function PwaInstallSafariIos26() {
  return (
    <NativeMockBackground>
      <InstallCard />
    </NativeMockBackground>
  );
}
